const importAll = (req: any) => {
  let modules: any = {}
  req.keys().forEach((key: any) => {
    const moduleName = key.replace("./", "").replace(".tsx", "")

    if (moduleName == "PageList") {
      return
    }

    modules[moduleName] = req(key).default
  })
  return modules
}

const loadPages = () => {
  const pages = importAll(require.context("../pages", false, /\.tsx$/))
  return pages
}

export default loadPages
